import { globalStyle, style, styleVariants } from '../layer.css.ts';
import { white } from '../palette.ts';
import { finePointerHover } from '../theme-v2/fine-pointer-hover.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { borderRadius, fonts, fontWeight, space } from '../tokens';
import { typography } from '../typography';

export const toggleGroupV2 = styleVariants({
  outline: {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
    minWidth: 0,
    overflowX: 'auto',
    scrollbarWidth: 'none',
  },
  segmented: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    height: 36,
    padding: space.s4,
    borderRadius: borderRadius.r8,
    boxShadow: hairline(white[50]),
  },
});

const toggleV2Base = style({
  appearance: 'none',
  boxSizing: 'border-box',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  margin: 0,
  border: 0,
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  cursor: 'pointer',
  fontFamily: fonts.sans,
  userSelect: 'none',
  transitionDuration: '0.15s',
  transitionProperty: 'background-color, color, box-shadow',
  selectors: {
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: `2px solid ${themeV2.color.border.focus}`,
      outlineOffset: '-1px',
    },
    '&[data-disabled]': {
      cursor: 'default',
    },
  },
});

export const toggleV2 = styleVariants({
  outline: [
    toggleV2Base,
    {
      ...typography.labelMd,
      height: 36,
      padding: `0 ${space.s16}px`,
      borderRadius: borderRadius.r8,
      backgroundColor: 'transparent',
      boxShadow: hairline(white[50]),
      color: themeV2.color.text.quaternary,
      '@media': {
        [finePointerHover]: {
          selectors: {
            '&:hover:not([data-disabled]):not([data-pressed]):not([aria-pressed="true"])':
              {
                backgroundColor: themeV2.color.bg.interactive.hover,
                color: white[800],
              },
          },
        },
      },
      selectors: {
        '&[data-pressed], &[aria-pressed="true"]': {
          backgroundColor: white[50],
          color: themeV2.color.text.primary,
        },
      },
    },
  ],
  segmented: [
    toggleV2Base,
    {
      ...typography.bodyMd,
      fontWeight: fontWeight.regular,
      height: 28,
      padding: `0 ${space.s16}px`,
      borderRadius: 500,
      backgroundColor: 'transparent',
      color: themeV2.color.text.quaternary,
      '@media': {
        [finePointerHover]: {
          selectors: {
            '&:hover:not([data-disabled]):not([data-pressed]):not([aria-pressed="true"])':
              {
                color: white[900],
              },
          },
        },
      },
      selectors: {
        '&[data-pressed], &[aria-pressed="true"]': {
          borderRadius: borderRadius.r8,
          backgroundColor: white[50],
          boxShadow: hairline(white[50]),
          color: themeV2.color.text.primary,
        },
      },
    },
  ],
});

globalStyle(`.${toggleGroupV2.outline}::-webkit-scrollbar`, {
  display: 'none',
});
